import {gql, MaybeMasked} from "@apollo/client";
import client from "~/apollo/client"; // Centralized Apollo Client
import { QueryTeamArgs, QueryTeamsArgs, Team } from "~/apollo/graphql";
import {ApolloQueryResult} from "@apollo/client/core/types";

const TEAMS_QUERY_BY_ORGANIZATION = gql`
    query Teams($organizationId: ID!) {
        teams(organizationId: $organizationId) {
            id
            name
            description
            organizationId
            active
            createdAt
            modifiedAt
        }
    }
`;

const TEAMS_QUERY_BY_ID = gql`
    query Team ($teamId: ID!) {
        team(id: $teamId) {
            id
            name
            description
            organizationId
            active
            createdAt
            modifiedAt
        }
    }
`;

export const getTeam = (input: QueryTeamArgs): Promise<ApolloQueryResult<{ team: Team }>> => {
    return client.query<{
        team: Team;
    }, QueryTeamArgs>({
        query: TEAMS_QUERY_BY_ID,
        variables: input,
    });
};

export const getTeams = async (input: QueryTeamsArgs): Promise<Team[]> => {
    const result = await client.query<{
        teams: Team[];
    }, QueryTeamsArgs>({
        query: TEAMS_QUERY_BY_ORGANIZATION,
        variables: input,
    });

    if (!result.data) {
        throw new Error("No data returned from teams query");
    }

    return result.data.teams;
};